import React, { useEffect, useCallback } from 'react';
import {
  listProductManagers,
  createProductManager,
  updateProductManager,
  searchUsersForProductManager,
} from 'js/actions/product-manager-actions';

import { connect } from 'react-redux';
import { useQuery } from 'js/hooks/useQuery';
import { SCHEMAS } from 'js/api/schemas';
import { useParams } from 'react-router-dom';

import { ProductManagersDashboard as ProductManagersDashboardComponent } from '../components/ProductManagersDashboard';

function ProductManagersDashboard({
  listProductManagers,
  createProductManager,
  updateProductManager,
  searchUsersForProductManager,
}) {
  const { workspaceId } = useParams();

  const refreshRecentQuery = useCallback(
    (queryId) => listProductManagers(queryId),
    [listProductManagers]
  );

  const {
    refresh: refreshProductManagers,
    result: productManagers,
    hasLoaded: productManagersHaveLoaded,
    isLoading: productManagersIsLoading,
  } = useQuery({
    queryId: `product-managers-${workspaceId}`,
    query: refreshRecentQuery,
    schema: SCHEMAS.PRODUCT_MANAGER_ARRAY,
  });

  useEffect(() => {
    refreshProductManagers();
  }, [refreshProductManagers]);

  const handleAddProductManager = useCallback(
    async (productManager) => {
      const result = await createProductManager(productManager);
      await refreshProductManagers();
      return result;
    },
    [createProductManager, refreshProductManagers]
  );

  const handleUpdateProductManager = useCallback(
    async (productManager) => {
      const result = await updateProductManager(productManager);
      await refreshProductManagers();
      return result;
    },
    [updateProductManager, refreshProductManagers]
  );

  const handleSearchUsers = useCallback(
    async (query) => {
      const trimmedQuery = query.trim();
      if (trimmedQuery.length === 0) {
        return [];
      }

      try {
        const result = await searchUsersForProductManager(trimmedQuery);
        return result || [];
      } catch (error) {
        console.error('Failed to search users:', error);
        return [];
      }
    },
    [searchUsersForProductManager]
  );

  return (
    <ProductManagersDashboardComponent
      productManagers={productManagers}
      hasLoaded={productManagersHaveLoaded}
      isLoading={productManagersIsLoading}
      onAddProductManager={handleAddProductManager}
      onUpdateProductManager={handleUpdateProductManager}
      onSearch={handleSearchUsers}
    />
  );
}

export default connect(null, {
  listProductManagers,
  createProductManager,
  updateProductManager,
  searchUsersForProductManager,
})(ProductManagersDashboard);
